module.exports = __webpack_public_path__ + "img/image-14.ef136535.jpeg";